const LISTAGEM_VAZIA = {
  pagamentos: [],
  encarregados: [],
  totalEncarregados: 0,
};

const RESUMO_VAZIO = {
  colunas: [],
  linhas: [],
  encarregados: [],
  totalEncarregados: 0,
};

function lerTotalEncarregados(response) {
  return Number(response?.totalEncarregados ?? 0);
}

function valorPagamento(item) {
  return Number(item?.valor ?? 0);
}

function idColaborador(item) {
  return item?.colaborador ?? item?.glo_vinculo_id;
}

export function normalizarPagamentosColheita(response) {
  if (!response || typeof response !== 'object') {
    return { ...LISTAGEM_VAZIA, totalComEncarregados: 0 };
  }

  const pagamentos = Array.isArray(response.pagamentos)
    ? response.pagamentos
    : [];
  const encarregados = Array.isArray(response.encarregados)
    ? response.encarregados
    : [];
  const totalEncarregados = lerTotalEncarregados(response);
  const totalColaboradores = pagamentos.reduce(
    (acc, item) => acc + valorPagamento(item),
    0,
  );

  return {
    pagamentos,
    encarregados,
    totalEncarregados,
    totalComEncarregados: totalColaboradores + totalEncarregados,
  };
}
export function normalizarResumoColheita(response) {
  if (!response || typeof response !== 'object') {
    return RESUMO_VAZIO;
  }

  return {
    colunas: response.colunas ?? [],
    linhas: response.linhas ?? [],
    encarregados: response.encarregados ?? [],
    totalEncarregados: lerTotalEncarregados(response),
  };
}

export function isLinhaEncarregado(pagamento) {
  return String(pagamento?.obs ?? '')
    .trim()
    .toLowerCase()
    .startsWith('encarregado');
}

function idsEncarregados(encarregados) {
  return new Set(
    encarregados.map((item) => item.colaborador?.id).filter(Boolean),
  );
}

export function isPagamentoSomenteEncarregado(pagamento, encarregados) {
  if (!pagamento) return false;
  if (isLinhaEncarregado(pagamento)) return true;

  const colaboradorId = idColaborador(pagamento);
  const semColheita = !pagamento.historico?.length;

  return idsEncarregados(encarregados).has(colaboradorId) && semColheita;
}

export function filtrarPagamentosColaboradores(pagamentos, encarregados) {
  if (!Array.isArray(pagamentos)) return [];

  return pagamentos.filter(
    (item) => !isPagamentoSomenteEncarregado(item, encarregados),
  );
}

function encarregadosDePagamentosTrancados(pagamentos) {
  const vistos = new Set();

  return pagamentos
    .filter(isLinhaEncarregado)
    .filter((item) => {
      const id = idColaborador(item);
      if (vistos.has(id)) return false;
      vistos.add(id);
      return true;
    })
    .map((item) => ({
      turmaId: item.turma_id,
      turmaDescricao: item.turmaDescricao ?? '—',
      colaborador: {
        id: idColaborador(item),
        razao_social: item.razao_social || item.nome,
      },
      valorPorMedida: Number(item.valorPorMedida ?? 0),
      totalMedidasEquipe: Number(item.totalMedidasEquipe ?? 0),
      totalReceber: valorPagamento(item),
    }));
}

export function resolverEncarregadosParaExibicao(pagamentos, encarregadosApi) {
  if (encarregadosApi?.length) {
    return encarregadosApi;
  }

  return encarregadosDePagamentosTrancados(pagamentos ?? []);
}

export function montarBodyTrancarFolhaColheita({
  categoria,
  fazenda,
  folha,
  fazendaAtivaId,
}) {
  const forma =
    folha?.forma || (Number(folha?.pagamento) === 1 ? 'individual' : '');

  return {
    forma,
    ...(categoria != null ? { categoria } : {}),
    ...(fazenda != null || fazendaAtivaId != null
      ? { fazenda: fazenda ?? fazendaAtivaId }
      : {}),
  };
}

export function somarValoresPagamentos(pagamentos) {
  if (!Array.isArray(pagamentos)) return 0;

  return pagamentos.reduce((acc, item) => acc + valorPagamento(item), 0);
}
